import { useTranslation } from 'react-i18next';
import { trackTrendyolConversion } from '../../../hooks/useConversionTracking';

export default function Features() {
  const { t } = useTranslation();

  const features = [
    {
      icon: 'ri-drop-line',
      title: t('features.hygiene'),
      description: t('features.hygieneDesc')
    },
    {
      icon: 'ri-focus-3-line',
      title: t('features.antiSlip'),
      description: t('features.antiSlipDesc')
    },
    {
      icon: 'ri-leaf-line',
      title: t('features.eco'),
      description: t('features.ecoDesc')
    },
    {
      icon: 'ri-palette-line',
      title: t('features.colors'),
      description: t('features.colorsDesc')
    },
    {
      icon: 'ri-hand-heart-line',
      title: t('features.comfort'),
      description: t('features.comfortDesc')
    },
    {
      icon: 'ri-shield-check-line',
      title: t('features.quality'),
      description: t('features.qualityDesc')
    }
  ];

  return (
    <section id="features" className="py-24 bg-white relative">
      <a
        href="https://ty.gl/1xexcnsg70rfw"
        target="_blank"
        rel="noopener noreferrer nofollow"
        onClick={trackTrendyolConversion}
        className="absolute top-6 right-6 z-10 cursor-pointer hover:opacity-80 transition-opacity duration-300"
      >
        <div className="w-10 h-10 flex items-center justify-center">
          <img 
            src="https://static.readdy.ai/image/1681d69a5b156bf16fd7f9a96245b161/1225b9f0757d6eda468a41a32e7f04b6.png" 
            alt="Shop on Trendyol" 
            title="Shop on Trendyol"
            className="w-full h-full object-contain"
          />
        </div>
      </a>
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            {t('features.title')}
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            {t('features.subtitle')}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div
              key={index}
              className="bg-gradient-to-br from-red-50 to-orange-50 rounded-2xl p-8 hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1"
            >
              <div className="w-14 h-14 bg-red-600 rounded-xl flex items-center justify-center mb-6">
                <i className={`${feature.icon} text-2xl text-white`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                {feature.title}
              </h3>
              <p className="text-sm text-gray-600 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-20 bg-gradient-to-r from-red-600 to-orange-600 rounded-3xl overflow-hidden">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-0">
            <div className="relative w-full h-96 lg:h-auto">
              <img
                src="https://static.readdy.ai/image/1681d69a5b156bf16fd7f9a96245b161/4b24b4ef28aebe02ef3709f34e7d5284.jpeg"
                alt="Dot Technology Detail"
                className="w-full h-full object-cover object-center"
              />
            </div>
            <div className="p-12 flex flex-col justify-center">
              <h3 className="text-3xl md:text-4xl font-bold text-white mb-6">
                {t('features.techTitle')}
              </h3>
              <p className="text-lg text-white/90 mb-6 leading-relaxed">
                {t('features.techDesc')}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}